import BaseStore from './baseStore'
import { queryString } from '../../utils/window'
import { addReducer } from '../../application/appStore'
import { TYPES as slideshowActions } from '../actions/slideshowActions'
import { stateKey, slideshowReducer } from '../components/slideshow/slideshowReducer'

const { adsDebugRefresh } = queryString
const {
  START_SLIDE_CHANGE,
  COMPLETE_SLIDE_CHANGE,
  SLIDESHOW_INITIALIZATION_FINISHED,
} = slideshowActions

class SlideshowStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.merge({
      currentSlideIndex: 0,
      newSlideIndex: 0,
      navigationButtonsLoaded: false,
    })
    addReducer(stateKey, slideshowReducer)
  }

  routeAction(action) {
    switch (action.type) {
      case START_SLIDE_CHANGE:
        adsDebugRefresh && this.info('START_SLIDE_CHANGE', { action })
        return this.startSlideChange(action.slideEventObject)
      case COMPLETE_SLIDE_CHANGE:
        return this.completeSlideChange(action.slideId)
      case SLIDESHOW_INITIALIZATION_FINISHED:
        return this.slideshowInitializationFinished()
      default:
    }
    return this
  }

  get initializationFinished() {
    return this.state.initializationFinished
  }
  set initializationFinished(bool) {
    this.state.initializationFinished = bool
  }
  get currentSlideIndex() {
    return this.state.currentSlideIndex
  }
  set currentSlideIndex(slideId) {
    this.state.currentSlideIndex = slideId
  }

  startSlideChange(slideEventObject) {
    const { slideId } = slideEventObject
    if (slideId >= 0) {
      return this.emitChange(slideId)
    }
  }

  completeSlideChange(slideId) {
    this.currentSlideIndex = slideId
  }

  slideshowInitializationFinished() {
    this.initializationFinished = true
  }
}

const slideshowStore = SlideshowStore.create()

export default slideshowStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/slideshowStore.js